import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import '../assets/css/AmMenu.scss';
import { lowcode } from '..';
let AmMenu = class AmMenu extends Vue {
  constructor() {
    super(...arguments);
    this.isCollapse = false;
    this.isHover = false;
    this.iconSize = 16;
    this.checkCustomMethod = true;
  }
  handleSelect(index, path) {
    if (this.checkCustomMethod) {
      const data = this.getDataByPath(path);
      if (data && data.method) {
        if (typeof data.method == 'function') {
          data.method(data);
        } else {
          // 通过am api打开相应的链接
          lowcode.navigate(data.method);
        }
      }
    }
  }
  handleOpen() {}
  handleClose() {}
  handleCollapseChange(newval, oldval) {
    this.$emit('collapse', newval);
  }
  triggerCollapse() {
    this.isCollapse = !this.isCollapse;
    this.isHover = this.isCollapse;
  }
  getDataByPath(arr) {
    let res = arr.concat();
    let root = this.data || [];
    let current = null;
    let paths = [];
    while (true) {
      let path = res.shift();
      paths.push(path);
      let find = root.find(item => {
        return item.index == path;
      });
      if (!find) {
        break;
      } else {
        var _find$children;
        let childs = (_find$children = find.children) !== null && _find$children !== void 0 ? _find$children : [];
        let item = [];
        for (let i = 0; i < childs.length; i++) {
          if (childs[i].isGroup) {
            var _childs$i$children;
            item = item.concat((_childs$i$children = childs[i].children) !== null && _childs$i$children !== void 0 ? _childs$i$children : []);
          } else {
            var _childs$i;
            item = item.concat((_childs$i = childs[i]) !== null && _childs$i !== void 0 ? _childs$i : []);
          }
        }
        root = item;
        current = find;
      }
    }
    return current;
  }
  leftEnter() {
    if (this.isHover) this.isCollapse = false;
  }
  leftLeave() {
    if (this.isHover) this.isCollapse = true;
  }
  render(h) {
    const {
      title,
      data,
      defaultActive,
      mode,
      uniqueOpened,
      menuWidth,
      menuTrigger,
      showCollapse,
      isCollapse,
      isHover,
      handleSelect,
      handleOpen,
      handleClose,
      triggerCollapse,
      leftEnter,
      leftLeave
    } = this;
    const renderMenuItem = (data, subIndex) => {
      return data.map((item, index) => {
        var _item$groups, _item$children, _item$children2;
        let iconType = item.iconType || 'default';
        let iconName = item.iconName || '';
        if (!item.iconName && !item.iconType) {
          if (item.icon) {
            iconType = 'default';
            iconName = item.icon.startsWith('yxt-icon-') ? item.icon.split('yxt-icon-')[1] : item.icon;
          }
          if (item.svgIcon) {
            iconType = 'svg';
            iconName = item.svgIcon;
          }
        }
        if (item !== null && item !== void 0 && (_item$groups = item.groups) !== null && _item$groups !== void 0 && _item$groups.length || item !== null && item !== void 0 && item.isGroup && item !== null && item !== void 0 && (_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
          const list = (item === null || item === void 0 ? void 0 : item.children) || (item === null || item === void 0 ? void 0 : item.groups) || [];
          return h("yxt-menu-item-group", {
            "attrs": {
              "title": item.title
            }
          }, [renderMenuItem(list, `${subIndex ? `${subIndex}-` : subIndex}${index++}`)]);
        } else if (item !== null && item !== void 0 && (_item$children2 = item.children) !== null && _item$children2 !== void 0 && _item$children2.length) {
          return h("yxt-submenu", {
            "attrs": {
              "index": item.index || subIndex,
              "disabled": item.disabled
            }
          }, [h("template", {
            "slot": "title"
          }, [iconName ? h("am-icon", {
            "class": "lc-am-menu-icon",
            "attrs": {
              "icon-type": iconType,
              "name": iconName,
              "size": this.iconSize
            }
          }) : null, h("span", [item.title])]), renderMenuItem(item.children, `${subIndex ? `${subIndex}-` : subIndex}${index++}`)]);
        } else {
          return h("yxt-menu-item", {
            "attrs": {
              "index": item.index || subIndex,
              "disabled": item.disabled
            }
          }, [iconName ? h("am-icon", {
            "class": "lc-am-menu-icon",
            "attrs": {
              "icon-type": iconType,
              "name": iconName,
              "size": this.iconSize
            }
          }) : null, h("span", {
            "slot": "title"
          }, [item.title])]);
        }
      });
    };
    return h("div", {
      "style": {
        width: isHover ? '64px' : menuWidth,
        paddingBottom: mode === 'vertical' && showCollapse ? '48px' : '0'
      },
      "class": ['lc-am-menu-transition', {
        'lc-am-menu_vertical': mode === 'vertical'
      }]
    }, [h("div", {
      "style": {
        width: isCollapse ? '64px' : menuWidth,
        paddingBottom: mode === 'vertical' && showCollapse ? '48px' : '0'
      },
      "class": ['lc-am-menu_box', 'lc-am-menu-transition']
    }, [mode === 'vertical' && (title ? h("div", {
      "class": "lc-am-menu_title"
    }, [title]) : !isCollapse && h("div", {
      "class": "lc-am-menu_slot_header"
    }, [this.$slots.header])), h("yxt-menu", _mergeJSXProps([{
      "attrs": {
        "default-active": defaultActive,
        "mode": mode,
        "collapse": isCollapse,
        "unique-opened": uniqueOpened,
        "menu-trigger": menuTrigger,
        "collapse-transition": false
      },
      "on": {
        "select": handleSelect,
        "open": handleOpen
      }
    }, {
      "nativeOn": {
        mouseenter: leftEnter,
        mouseleave: leftLeave
      }
    }, {
      "on": {
        "close": handleClose
      }
    }]), [renderMenuItem(data)]), mode === 'vertical' && showCollapse && h("div", {
      "class": "lc-am-menu_aside-bottom"
    }, [h("yxt-svg", _mergeJSXProps2([{}, {
      "nativeOn": {
        click: triggerCollapse
      }
    }, {
      "attrs": {
        "icon-class": "collapse",
        "remote-url": lowcode.utils.url2cdn('assets/e57f23c2/f7b885e3'),
        "width": "18px",
        "height": "18px"
      },
      "class": true,
      "style": {
        transform: isCollapse ? 'rotate(180deg)' : ''
      }
    }]))])])]);
  }
};
AmMenu.componentName = 'AmMenu';
__decorate([Prop({
  default: ''
})], AmMenu.prototype, "title", void 0);
__decorate([Prop({
  default: () => []
})], AmMenu.prototype, "data", void 0);
__decorate([Prop({
  default: 'vertical'
})], AmMenu.prototype, "mode", void 0);
__decorate([Prop({
  default: false
})], AmMenu.prototype, "uniqueOpened", void 0);
__decorate([Prop({
  default: 'hover'
})], AmMenu.prototype, "menuTrigger", void 0);
__decorate([Prop({
  default: ''
})], AmMenu.prototype, "defaultActive", void 0);
__decorate([Prop({
  default: '184px'
})], AmMenu.prototype, "menuWidth", void 0);
__decorate([Prop({
  default: true
})], AmMenu.prototype, "showCollapse", void 0);
__decorate([Emit('select')], AmMenu.prototype, "handleSelect", null);
__decorate([Emit('open')], AmMenu.prototype, "handleOpen", null);
__decorate([Emit('close')], AmMenu.prototype, "handleClose", null);
__decorate([Watch('isCollapse')], AmMenu.prototype, "handleCollapseChange", null);
AmMenu = __decorate([Component({
  name: 'AmMenu'
})], AmMenu);
export default AmMenu;